import { useState } from "react";
import { login } from "@services/authenticationService";
import { useLoginGateway } from "@hooks/store";
import { useAuthSession } from "./useAuthSession";
import { buildPasswordLoginPayload } from "./loginPayloads";

type UsePasswordLoginParams = {
  mobileNumber: string;
  countryCode?: string;
  /** Admission flow only — omitted for mobile login */
  admissionNo?: string;
  onAuthenticated?: () => void;
};

export function usePasswordLogin({
  mobileNumber,
  countryCode = "+91",
  admissionNo,
  onAuthenticated,
}: UsePasswordLoginParams) {
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const loginGateway = useLoginGateway();
  const { completeLogin } = useAuthSession({ onAuthenticated });

  const loginWithPassword = async (password: string) => {
    setError("");
    setIsLoading(true);
    try {
      const res = await login(
        buildPasswordLoginPayload(
          mobileNumber,
          password,
          countryCode,
          admissionNo
        ),
        loginGateway
      );

      if (res?.accessToken) {
        const result = await completeLogin(res.accessToken);
        if (!result.success) {
          setError(result.error);
        }
      } else {
        setError("Incorrect Password! Try again");
      }
    } catch (err: unknown) {
      const message =
        (err as { detail?: string; message?: string })?.detail ||
        (err as { message?: string })?.message ||
        "Incorrect Password! Try again";
      setError(message);
    } finally {
      setIsLoading(false);
    }
  };

  return { error, setError, isLoading, loginWithPassword };
}
